// TODO: Need to establish where we put our global scss mixins
@mixin transform($transforms) {
  -webkit-transform: $transforms;
  -moz-transform: $transforms;
  -ms-transform: $transforms;
  transform: $transforms;
}
@mixin rotate($deg) {
  @include transform(rotate(#{$deg}deg));
}
// transitions
@mixin transition($transitions) {
  -webkit-transition: $transitions;
  -moz-transition: $transitions;
  transition: $transitions;
}

:host {
  display: block;
  /** @prop --read-more-font-size: Set the font size of the read more text. */
  --read-more-font-size: var(--s-size-text-default);

  /** @prop --read-more-font-size: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --font-size: var(--read-more-font-size);

  /** @prop --read-more-font-family: Set the font family of the read more text. */
  --read-more-font-family: var(--s-font-family-paragraph);

  /** @prop --read-more-font-family: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --font-family: var(--read-more-font-family);

  /** @prop --read-more-font-weight: Set the font weight of the read more text. */
  --read-more-font-weight: var(--s-font-weight-paragraph-default);

  /** @prop --read-more-font-weight: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --font-weight: var(--read-more-font-weight);

  /** @prop --read-more-line-height: Set the line height of the read more text. */
  --read-more-line-height: var(--s-size-line-height-paragraph);

  /** @prop --read-more-line-height: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --line-height: var(--read-more-line-height);

  /** @prop --read-more-link-text-color: Set the text color of the read more link. */
  --read-more-link-text-color: var(--s-color-text-default);

  /** @prop --read-more-link-text-color: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --link-text-color: var(--read-more-link-text-color);

  /** @prop --read-more-link-text-color-hover: Set the text color of the read more link on hover. */
  --read-more-link-text-color-hover: var(--s-color-text-default);

  /** @prop --read-more-link-text-color-hover: DEPRECATED: kept for backwards compatibility, but will be removed by April 2024 */
  --link-text-color-hover: var(--read-more-link-text-color-hover);

  /** @prop --read-more-text-color: Set the text color of the read more content. */
  --read-more-text-color: var(--s-color-text-default);

  /** @prop --read-more-icon-color: Set the color of the read more icon. */
  --read-more-icon-color: var(--s-color-icon-default);

  /** @prop --read-more-border-width: Set the width of the bottom border  */
  --read-more-border-width: var(--p-size-static-0125);
}

.anchor-c-read-more {
  display: flex;
  flex-direction: column;
  gap: var(--p-size-static-100);
  color: var(--read-more-text-color);
  font-size: var(--read-more-font-size);
  font-family: var(--read-more-font-family);
  font-weight: var(--read-more-font-weight);
  line-height: var(--read-more-line-height);
  &--emphasized {
    --read-more-link-text-color: var(--s-color-text-cta-default);
    --read-more-icon-color: var(--s-color-icon-cta-default);
  }
  &__link {
    box-sizing: border-box;
    width: fit-content;
    cursor: pointer;
    display: inline-flex;
    gap: 0;
    background: none;
    border: none;
    box-shadow: inset 0 calc(-1 * var(--read-more-border-width)) 0 0 var(--read-more-link-text-color);
    padding: 0;
    color: var(--read-more-link-text-color);
    font-size: var(--read-more-font-size);
    font-family: var(--read-more-font-family);
    font-weight: var(--read-more-font-weight);
    line-height: var(--read-more-line-height);
    text-decoration: none;
    text-align: left;
    @media (hover: hover) {
      &:hover {
        --read-more-border-width: var(--p-size-static-025);
      }
    }
    &:focus-visible {
      outline: var(--p-size-static-025) solid var(--read-more-link-text-color-hover);
    }
  }
  &__text {
    display: none;
  }
  &__icon {
    color: var(--read-more-icon-color);
    height: var(--p-size-static-300);
  }
  &.expanded {
    .anchor-c-read-more__text {
      display: block;
    }
    .anchor-c-read-more__icon {
      @include rotate(-180);
    }
  }
}
